import React, { useEffect, useState } from "react";
import css from "../css/Mywallet.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import socket from "../Components/socket";
import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
import { BsWallet2 } from "react-icons/bs";
import io from "../Components/socket";
import Swal from 'sweetalert2';

const Mywallet = ({ user }) => {
  // const [user, setUser] = useState();

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const access_token = localStorage.getItem("token");
  //   const walletUpdate =()=>{
  //  io.emit("getprofile", access_token);
  //   io.on("setProfile", (data) => {
  //     setUser(data);
  //   });
  //   }

  //   useEffect(()=>{
  //     walletUpdate()
  //   },[]);

  return (
    <>
      <div className="leftContainer mb_space">
        <div className="pt-5 mt-5   Orher_page_main_section">

          <div className="wallet_dashboard_wrapper mt-3">
          
                      {/* DEPOSIT CARD */}
                      <div className="premium_wallet_card deposit_card_new">
                        <div className="card_header_modern">
                          <span className="dot_indicator"></span>
                          Deposit Cash
                        </div>
          
                        <div className="card_balance_body">
                          <div className="balance_display_circle">
                            <div className="icon_inner_box">
                              <img src={process.env.PUBLIC_URL + 'images/global-rupeeIcon.png'} alt="chips" />
                            </div>
                            <div className="balance_text_info">
                              <h2 className="main_amt">₹{user && user.Wallet_balance}</h2>
                              <p className="sub_text">Current Chips</p>
                            </div>
                          </div>
                        </div>
          
                        <Link to="/addcase" className="action_link_wrapper">
                          <button className="modern_action_btn deposit_btn_vibe">
                            Add Cash <i className="fa-solid fa-plus ml-2"></i>
                          </button>
                        </Link>
                      </div>
          
                      {/* WITHDRAW CARD */}
                      <div className="premium_wallet_card withdraw_card_new">
                        <div className="card_header_modern">
                          <span className="dot_indicator alert_dot"></span>
                          Withdraw Cash
                        </div>
          
                        <div className="card_balance_body">
                          <div className="balance_display_circle">
                            <div className="icon_inner_box winning_box">
                              <img src={process.env.PUBLIC_URL + 'images/global-rupeeIcon.png'} alt="chips" />
                            </div>
                            <div className="balance_text_info">
                              <h2 className="main_amt">₹{user && user.withdrawAmount}</h2>
                              <p className="sub_text">Winning Cash</p>
                            </div>
                          </div>
                        </div>
          
                        <Link to='/Withdrawopt' className="action_link_wrapper">
                          <button className="modern_action_btn withdraw_btn_vibe">
                            Withdraw <i className="fa-solid fa-arrow-up-right-from-square ml-2"></i>
                          </button>
                        </Link>
                      </div>
          
                    </div>
        </div>
        <div className="rightContainer">
          <div>
            <Rightcontainer />
          </div>
        </div>
      </div>
    </>
  );
};
export default Mywallet;
